/*!

=========================================================
* Argon Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// reactstrap components
import {
  Button,
  Card,
  Table,
  Container,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  Input,
  Modal,
  FormGroup,
  Form,
  Alert,
} from "reactstrap";
// core components

import _ from "underscore";

import API from "api/api/API";

import { Link } from "react-router-dom";
import { AppConfirm } from "utils/PopupUtil";
import AppSpinner from "../../elements/AppSpinner";
import AppHelmet from "../../components/AppComponents/AppHelmet";

class GlobalVariableConstantsView extends React.Component {
  state = {
    loading: false,
    variables: [],
  };

  constructor(props) {
    super(props);

    this.tableRef = React.createRef();
  }

  handleInputChange(evt) {
    const value = evt.target.value;
    this.setState({
      [evt.target.name]: value,
    });
  }

  handleModifySelectChange(evt) {
    const value = evt.target.value;

    if (value == "boolean") {
      this.setState({
        [evt.target.name]: value,
        modifyValue: false,
      });
    } else {
      this.setState({
        [evt.target.name]: value,
      });
    }
  }

  handleCheckboxChange(evt) {
    const value = evt.target.checked;
    this.setState({
      [evt.target.name]: value,
    });
  }

  handleCreateNameChange(evt) {
    let value = evt.target.value;

    value = value.split(" ").join("");
    value = value.split("/").join("");
    value = value.split("\\").join("");

    this.setState({
      [evt.target.name]: value,
    });
  }

  openModifyModal(v) {
    let type = typeof v.Value;
    let val = v.Value;

    if (typeof v.Value === "number") {
      if (v.Value % 1 != 0) {
        type = "float";
      } else {
        type = "int";
      }
    }

    if (typeof v.Value === "object") {
      if (v.Value !== null) {
        try {
          val = JSON.stringify(v.Value);
        } catch (e) {
          val = "";
        }
      }
    }

    this.setState({
      modifyOriginalName: v.Name,
      modifyName: v.Name,
      modifyValue: val,
      modifyType: type,
    });

    this.toggleModal("modifyModal");
  }

  valueToString(val) {
    if (typeof val === "string") {
      return val;
    }

    if (typeof val === "boolean") {
      return val ? "True" : "False";
    }

    if (typeof val === "object") {
      return JSON.stringify(val);
    }

    return val.toString();
  }

  setError(name, val = null) {
    if (!val) {
      this.setState({
        [name]: "",
      });

      return;
    }

    this.setState({
      [name]: val,
    });

    setTimeout(() => {
      this.setError(name);
    }, 4000);
  }

  handleAPINameChange(evt) {
    let value = evt.target.value;

    value = value.split(" ").join("");
    value = value.split("/").join("");
    value = value.split("\\").join("");

    this.setState({
      [evt.target.name]: value,
    });
  }

  delete(v) {
    AppConfirm({
      title: `Delete ${v.Name} Variable?`,
      text: `Are you sure you want to delete the ${v.Name} variable. This cannot be undone.`,
    }).then((result) => {
      if (!result.isConfirmed) return;

      API.deleteGlobalVariableConstant(v.Name).then(
        (data) => {
          let fields = _.filter(this.state.variables, (f) => {
            return v.Name !== f.Name;
          });

          this.setState({
            variables: fields,
          });
        },
        (err) => {
          this.setError(
            "deleteError",
            "We were unable to delete the variable. Please try again."
          );
        }
      );
    });
  }

  getConstants() {
    this.setState({
      loading: true,
    });

    API.getGlobalVariableConstants().then(
      (data) => {
        this.setState({
          variables: data.data.data.constants,
          loading: false,
        });
      },
      (err) => {
        console.error(err);
      }
    );
  }

  create(e) {
    e.preventDefault();

    let value = this.state.createValue;

    if (this.state.createType == "int") {
      value = parseInt(value);

      if (isNaN(value)) {
        this.setError(
          "createError",
          "The integer value you entered is not a number."
        );

        return;
      }
    } else if (this.state.createType == "float") {
      value = parseFloat(value);

      if (isNaN(value)) {
        this.setError(
          "createError",
          "The float value you entered is not a number."
        );

        return;
      }
    } else if (this.state.createType == "object") {
      try {
        value = JSON.parse(value);
      } catch (e) {
        this.setError("createError", "The JSON object you entered is invalid.");

        return;
      }
    } else if (this.state.createType == "boolean") {
      value = value ? true : false;
    }

    this.setState({
      createSubmitting: true,
    });

    API.createGlobalVariableConstant(this.state.createName, value)
      .then(
        (data) => {
          let fields = this.state.variables;

          fields.push(data.data.data.constant);

          this.setState({
            variables: fields,
            create: "",
            createName: "",
            createType: null,
            createValue: null,
          });

          this.toggleModal("createModal");
        },
        (error) => {
          if (error.response && error.response.status == 409) {
            this.setError(
              "createError",
              "A variable with that Name already exists. Modify Name to continue."
            );
          } else {
            this.setError(
              "createError",
              "We were unable to create the variable. Please try again."
            );
          }

          console.error(error);
        }
      )
      .finally(() => {
        this.setState({
          createSubmitting: false,
        });
      });
  }

  modify(e) {
    e.preventDefault();

    let value = this.state.modifyValue;

    if (this.state.modifyType == "int") {
      value = parseInt(value);

      if (isNaN(value)) {
        this.setError(
          "modifyError",
          "The integer value you entered is not a number."
        );

        return;
      }
    } else if (this.state.modifyType == "float") {
      value = parseFloat(value);

      if (isNaN(value)) {
        this.setError(
          "modifyError",
          "The float value you entered is not a number."
        );

        return;
      }
    } else if (this.state.modifyType == "object") {
      try {
        value = JSON.parse(value);
      } catch (e) {
        this.setError("modifyError", "The JSON object you entered is invalid.");

        return;
      }
    } else if (this.state.modifyType == "boolean") {
      value = value ? true : false;
    }

    this.setState({
      modifySubmitting: true,
    });

    API.modifyGlobalVariableConstant(this.state.modifyOriginalName, value)
      .then(
        (data) => {
          let fields = this.state.variables;

          for (let i = 0; i < fields.length; i++) {
            if (fields[i].Name === this.state.modifyOriginalName) {
              fields[i] = data.data.data.constant;

              break;
            }
          }

          this.setState({
            variables: fields,
            modifyName: "",
            modifyType: null,
            modifyValue: null,
            modifyOriginalName: "",
          });

          this.toggleModal("modifyModal");
        },
        (error) => {
          if (error.response && error.response.status == 409) {
            this.setError(
              "createError",
              "A variable with that Name already exists. Modify the Name to continue."
            );
          } else {
            this.setError(
              "createError",
              "We were unable to modify the variable. Please try again."
            );
          }

          console.error(error);
        }
      )
      .finally(() => {
        this.setState({
          modifySubmitting: false,
        });
      });
  }

  componentDidMount() {
    this.getConstants();
  }

  toggleModal(state) {
    this.setState({
      [state]: !this.state[state],
    });
  }

  render() {
    return (
      <>
        <AppHelmet title="Global Variable Constants - GrowthCloud.com" />
        <div className="header pb-6">
          <Container fluid>
            <div className="header-body">
              <Row className="align-items-center py-4">
                <Col lg="auto" md="12">
                  <h6 className="h2 mb-0">Global Constants</h6>{" "}
                  <Breadcrumb
                    className="d-none d-md-block mt-1"
                    listClassName="breadcrumb-links"
                  >
                    <BreadcrumbItem>
                      <Link to={this.props.urlStart || "/supportal"}>
                        <i className="mdi mdi-rocket" />
                      </Link>
                    </BreadcrumbItem>
                    <BreadcrumbItem>Global Variables</BreadcrumbItem>
                    <BreadcrumbItem>Constants</BreadcrumbItem>
                  </Breadcrumb>
                </Col>
                <Col
                  className="text-lg-right mt-3 mt-lg-0"
                  lg=""
                  md="12"
                  style={{
                    overflowY: "scroll",
                    lineHeight: 1,
                    whiteSpace: "nowrap",
                  }}
                >
                  <Button
                    className="btn-icon btn-outline-primary"
                    color=""
                    onClick={() => this.toggleModal("createModal")}
                  >
                    <span className="btn-inner--icon">
                      <i className="mdi mdi-plus" style={{ top: "0px" }} />
                    </span>
                    <span className="btn-inner--text">New</span>
                  </Button>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
        <Container className="mt--6" fluid>
          <hr className="mt-0 mb-4"></hr>

          <Row>
            <Col xs="12">
              <Card>
                <Table
                  className="align-items-center table-flush"
                  id="globalFieldTypesTable"
                  responsive
                >
                  <thead className="thead-light">
                    <tr>
                      <th className="sort" data-sort="Name" scope="col">
                        Name
                      </th>

                      <th className="sort" data-sort="APIName" scope="col">
                        Type
                      </th>
                      <th className="sort" data-sort="APIName" scope="col">
                        Value
                      </th>
                      <th scope="col" />
                    </tr>
                  </thead>
                  <tbody className="list">
                    {this.state.loading ? (
                      <tr>
                        <th scope="row" colSpan="3">
                          Loading...
                        </th>
                      </tr>
                    ) : (
                      <>
                        {this.state.variables.length ? (
                          <>
                            {this.state.variables.map((f, i) => (
                              <tr key={i}>
                                <th scope="row" className="Name">
                                  {f.Name}
                                </th>
                                <td className="APIName">{typeof f.Value}</td>
                                <td className="APIName">
                                  {this.valueToString(f.Value)}
                                </td>

                                <td className="text-right">
                                  <Button
                                    size="sm"
                                    color=""
                                    className="btn-outline-secondary"
                                    onClick={() => this.openModifyModal(f)}
                                  >
                                    <span className="btn-inner--icon">
                                      <i
                                        className="mdi mdi-pencil mr-2"
                                        style={{ top: "0px" }}
                                      />
                                    </span>
                                    <span className="btn-inner--text">
                                      Edit
                                    </span>
                                  </Button>
                                  <Button
                                    size="sm"
                                    color=""
                                    className="btn-outline-danger"
                                    onClick={() => this.delete(f)}
                                  >
                                    <span className="btn-inner--icon">
                                      <i
                                        className="mdi mdi-delete mr-2"
                                        style={{ top: "0px" }}
                                      />
                                    </span>
                                    <span className="btn-inner--text">
                                      Delete
                                    </span>
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </>
                        ) : (
                          <tr>
                            <td colSpan="3">None.</td>
                          </tr>
                        )}
                      </>
                    )}
                  </tbody>
                </Table>
              </Card>
            </Col>
          </Row>
        </Container>
        <Modal
          className="modal-dialog-centered"
          isOpen={this.state.createModal}
          toggle={() => this.toggleModal("createModal")}
        >
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              Create Constant
            </h5>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("createModal")}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <Form onSubmit={this.create.bind(this)}>
            <div className="modal-body">
              <FormGroup>
                <h5>Name</h5>
                <Input
                  placeholder="Name"
                  type="text"
                  name="createName"
                  value={this.state.createName}
                  onChange={this.handleCreateNameChange.bind(this)}
                />
              </FormGroup>
              <FormGroup>
                <h5>Type</h5>
                <Input
                  placeholder="Type"
                  type="select"
                  name="createType"
                  value={this.state.createType}
                  onChange={this.handleInputChange.bind(this)}
                >
                  <option disabled={true} selected={true}>
                    Select A Type
                  </option>
                  <option value="string">String</option>
                  <option value="int">Integer</option>
                  <option value="float">Float</option>
                  <option value="boolean">Boolean</option>
                  <option value="object">JSON Object</option>
                </Input>
              </FormGroup>
              {this.state.createType == "string" ||
              this.state.createType == "object" ? (
                <FormGroup>
                  <h5>
                    Value{this.state.createType == "object" ? " (JSON)" : ""}
                  </h5>
                  <Input
                    placeholder="Value"
                    type="textarea"
                    name="createValue"
                    value={this.state.createValue}
                    onChange={this.handleInputChange.bind(this)}
                  />
                </FormGroup>
              ) : null}
              {this.state.createType == "int" ? (
                <FormGroup>
                  <h5>Value</h5>
                  <Input
                    placeholder="Value"
                    type="tel"
                    name="createValue"
                    value={this.state.createValue}
                    onChange={this.handleInputChange.bind(this)}
                  />
                </FormGroup>
              ) : null}
              {this.state.createType == "float" ? (
                <FormGroup>
                  <h5>Value</h5>
                  <Input
                    placeholder="Value"
                    type="text"
                    name="createValue"
                    value={this.state.createValue}
                    onChange={this.handleInputChange.bind(this)}
                  />
                </FormGroup>
              ) : null}
              {this.state.createType == "boolean" ? (
                <FormGroup>
                  <h5>Value</h5>
                  <label className="custom-toggle">
                    <input
                      onClick={this.handleCheckboxChange.bind(this)}
                      name="createValue"
                      value={this.state.createValue}
                      type="checkbox"
                    />
                    <span
                      className="custom-toggle-slider rounded-circle"
                      data-label-off="F"
                      data-label-on="T"
                    />
                  </label>
                </FormGroup>
              ) : null}

              {this.state.createError ? (
                <Alert color="warning" className="mt-3 mb-0">
                  {this.state.createError}
                </Alert>
              ) : null}
            </div>
            <div className="modal-footer">
              <Button
                color="secondary"
                data-dismiss="modal"
                type="button"
                onClick={() => this.toggleModal("createModal")}
              >
                Close
              </Button>
              <Button
                color="primary"
                type="submit"
                disabled={
                  this.state.createSubmitting ||
                  !this.state.createName ||
                  !this.state.createType
                }
              >
                {this.state.createSubmitting ? (
                  <AppSpinner style={{ height: 20, width: 20 }} color="white" />
                ) : (
                  <>Create</>
                )}
              </Button>
            </div>
          </Form>
        </Modal>
        <Modal
          className="modal-dialog-centered"
          isOpen={this.state.modifyModal}
          toggle={() => this.toggleModal("modifyModal")}
        >
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              Modify Constant
            </h5>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal("modifyModal")}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <Form onSubmit={this.modify.bind(this)}>
            <div className="modal-body">
              <FormGroup>
                <h5>Name</h5>
                <Input
                  placeholder="Name"
                  type="text"
                  value={this.state.modifyOriginalName}
                  readOnly={true}
                />
              </FormGroup>

              <FormGroup>
                <h5>Type</h5>
                <Input
                  placeholder="Type"
                  type="select"
                  name="modifyType"
                  value={this.state.modifyType}
                  onChange={this.handleModifySelectChange.bind(this)}
                >
                  <option disabled={true} selected={true}>
                    Select A Type
                  </option>
                  <option value="string">String</option>
                  <option value="int">Integer</option>
                  <option value="float">Float</option>
                  <option value="boolean">Boolean</option>
                  <option value="object">JSON Object</option>
                </Input>
              </FormGroup>
              {this.state.modifyType == "string" ||
              this.state.modifyType == "object" ? (
                <FormGroup>
                  <h5>
                    Value{this.state.modifyType == "object" ? " (JSON)" : ""}
                  </h5>
                  <Input
                    placeholder="Value"
                    type="textarea"
                    name="modifyValue"
                    value={this.state.modifyValue}
                    onChange={this.handleInputChange.bind(this)}
                  />
                </FormGroup>
              ) : null}
              {this.state.modifyType == "int" ? (
                <FormGroup>
                  <h5>Value</h5>
                  <Input
                    placeholder="Value"
                    type="tel"
                    name="modifyValue"
                    value={this.state.modifyValue}
                    onChange={this.handleInputChange.bind(this)}
                  />
                </FormGroup>
              ) : null}
              {this.state.modifyType == "float" ? (
                <FormGroup>
                  <h5>Value</h5>
                  <Input
                    placeholder="Value"
                    type="text"
                    name="modifyValue"
                    value={this.state.modifyValue}
                    onChange={this.handleInputChange.bind(this)}
                  />
                </FormGroup>
              ) : null}
              {this.state.modifyType == "boolean" ? (
                <FormGroup>
                  <h5>Value</h5>
                  <label className="custom-toggle">
                    <input
                      onClick={this.handleCheckboxChange.bind(this)}
                      name="modifyValue"
                      value={this.state.modifyValue}
                      type="checkbox"
                    />
                    <span
                      className="custom-toggle-slider rounded-circle"
                      data-label-off="F"
                      data-label-on="T"
                    />
                  </label>
                </FormGroup>
              ) : null}

              {this.state.modifyError ? (
                <Alert color="warning" className="mt-3 mb-0">
                  {this.state.modifyError}
                </Alert>
              ) : null}
            </div>
            <div className="modal-footer">
              <Button
                color="secondary"
                data-dismiss="modal"
                type="button"
                onClick={() => this.toggleModal("modifyModal")}
              >
                Close
              </Button>
              <Button
                color="primary"
                type="submit"
                disabled={
                  this.state.modifySubmitting ||
                  !this.state.modifyName ||
                  !this.state.modifyType
                }
              >
                {this.state.modifySubmitting ? (
                  <AppSpinner style={{ height: 20, width: 20 }} color="white" />
                ) : (
                  <>Save</>
                )}
              </Button>
            </div>
          </Form>
        </Modal>
      </>
    );
  }
}

export default GlobalVariableConstantsView;
